import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';

import videojs from 'video.js';

import { BaseViewerComponent } from '../base-viewer/base-viewer.component';

@Component({
    selector: 'sh-video-viewer',
    templateUrl: './video-viewer.component.html',
    styleUrls: ['./video-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None, // Allow custom styles to pass through
    standalone: true
})
export class VideoViewerComponent extends BaseViewerComponent implements AfterViewInit {
    private readonly FPS: number = 25;

    private player!: videojs.Player;
    private readonly offset = 0;

    @ViewChild('player', { static: false }) videoElement!: ElementRef;

    constructor() {
        super();
    }

    ngAfterViewInit(): void {
        this.initPlayer();
        this.initPlayerFeatures();
    }

    private initPlayer(): void {
        const playerOptions: videojs.PlayerOptions = {
            controls: true,
            playbackRates: [0.5, 1, 1.25, 1.5, 2, 4, 8],
            autoplay: false,
            preload: 'auto',
            techOrder: ['html5']
        };

        this.player = videojs(this.videoElement.nativeElement, playerOptions);

        const contentType = `video/${this.extension}`;
        this.player.src({ src: this.blobUrl, type: contentType });
        this.player.isFullscreen(true);
    }

    private initPlayerFeatures(): void {
        this.initTimeFormatConversion();
    }

    private initTimeFormatConversion(): void {
        videojs.setFormatTime(this.toTimeFormat.bind(this));
    }

    private toTimeFormat(time: number): string {
        if (Number.isNaN(time)) {
            time = 0;
        }

        time += this.offset / this.FPS;
        let timestring: string = new Date(1000 * time).toISOString().substr(11, 8);
        const frame: number = (time * this.FPS) % this.FPS;

        if (frame >= 10) {
            timestring += ':' + frame.toString().substr(0, 2);
        } else {
            timestring += ':0' + frame.toString().substr(0, 1);
        }
        return timestring;
    }
}
